/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeLocationCountries.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Location Country Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 05:55:18 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const LOCATIONCOUNTRY_LIST_CONTAINER_LOADED = 'LOCATIONCOUNTRY_LIST_CONTAINER_LOADED';
export const LOCATIONCOUNTRY_LIST_CONTAINER_UNLOADED = 'LOCATIONCOUNTRY_LIST_CONTAINER_UNLOADED';
export const LOCATIONCOUNTRY_LIST_TABLE_LOADED = 'LOCATIONCOUNTRY_LIST_TABLE_LOADED';
export const LOCATIONCOUNTRY_LIST_TABLE_UNLOADED = 'LOCATIONCOUNTRY_LIST_TABLE_UNLOADED';

export const LOCATIONCOUNTRY_LIST_CHANGE_GROUP = 'LOCATIONCOUNTRY_LIST_CHANGE_GROUP';
export const LOCATIONCOUNTRY_SELECT_ROW = 'LOCATIONCOUNTRY_SELECT_ROW';

export const LOCATIONCOUNTRY_ADD = 'LOCATIONCOUNTRY_ADD';
export const LOCATIONCOUNTRY_EDIT = 'LOCATIONCOUNTRY_EDIT';
export const LOCATIONCOUNTRY_DELETE = 'LOCATIONCOUNTRY_DELETE';
export const LOCATIONCOUNTRY_OPEN_WARNING = 'LOCATIONCOUNTRY_OPEN_WARNING';
export const LOCATIONCOUNTRY_CLOSE_WARNING = 'LOCATIONCOUNTRY_CLOSE_WARNING';
export const LOCATIONCOUNTRY_DELETE_DISABLE = 'LOCATIONCOUNTRY_DELETE_DISABLE';
export const LOCATIONCOUNTRY_VIEW_CHILD_ITEMS = 'LOCATIONCOUNTRY_VIEW_CHILD_ITEMS';

export const LOCATIONCOUNTRY_EDIT_CONTAINER_LOADED = 'LOCATIONCOUNTRY_EDIT_CONTAINER_LOADED';
export const LOCATIONCOUNTRY_EDIT_CONTAINER_UNLOADED = 'LOCATIONCOUNTRY_EDIT_CONTAINER_UNLOADED';
export const LOCATIONCOUNTRY_EDIT_FORM_LOADED = 'LOCATIONCOUNTRY_EDIT_FORM_LOADED';
export const LOCATIONCOUNTRY_EDIT_FORM_UNLOADED = 'LOCATIONCOUNTRY_EDIT_FORM_UNLOADED';

export const LOCATIONCOUNTRY_SET_GROUP_SELECT = 'LOCATIONCOUNTRY_SET_GROUP_SELECT';
export const LOCATIONCOUNTRY_EDIT_DATA_LOAD = 'LOCATIONCOUNTRY_EDIT_DATA_LOAD';

export const LOCATIONCOUNTRY_EDIT_CONTAINER_SUBMIT = 'LOCATIONCOUNTRY_EDIT_CONTAINER_SUBMIT';
export const LOCATIONCOUNTRY_EDIT_CONTAINER_CANCEL = 'LOCATIONCOUNTRY_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeLocationCountries.js